<template>
  <div class="max-w-4xl mx-auto">
    <!-- 页面标题 -->
    <div class="text-center mb-12">
      <h1 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-800 mb-4">退款与争议处理政策</h1>
      <p class="text-neutral-500 max-w-2xl mx-auto">本政策适用于EliteShop平台所有商品的退换货、退款及争议处理</p>
    </div>

    <div class="bg-white rounded-lg shadow-elevation-1 p-8 space-y-8">
      <!-- 政策更新时间 -->
      <div class="text-sm text-neutral-500 border-b border-neutral-200 pb-4">
        <p>最后更新时间：2025年1月1日</p>
      </div>

      <!-- 退换货政策 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">一、退换货政策</h2>
        
        <h3 class="font-medium text-lg mb-2">1.1 7天无理由退换货</h3>
        <p class="text-neutral-600 mb-3">
          除特殊商品外，您在收到商品之日起7天内，在商品完好、配件齐全、不影响二次销售的前提下，
          可以申请无理由退换货。
        </p>
        
        <h3 class="font-medium text-lg mb-2">1.2 适用范围</h3>
        <div class="bg-neutral-50 p-4 rounded-lg mb-4">
          <h4 class="font-medium mb-2">支持7天无理由退换货的商品：</h4>
          <ul class="space-y-1 text-neutral-600 pl-5 list-disc mb-3">
            <li>数码产品（手机、电脑、平板等）</li>
            <li>家电产品（冰箱、洗衣机、电视等）</li>
            <li>服装鞋帽、箱包配饰</li>
            <li>家居用品、厨具餐具</li>
            <li>美妆个护（未开封）</li>
          </ul>
          
          <h4 class="font-medium mb-2">不支持7天无理由退换货的商品：</h4>
          <ul class="space-y-1 text-neutral-600 pl-5 list-disc">
            <li>食品、保健品、饮料</li>
            <li>贴身用品（内衣、袜子、泳衣等）</li>
            <li>定制商品、个性化商品</li>
            <li>鲜活易腐商品</li>
            <li>虚拟商品（充值卡、激活码等）</li>
            <li>特价清仓商品（标注不退不换）</li>
          </ul>
        </div>
        
        <h3 class="font-medium text-lg mb-2">1.3 退换货条件</h3>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>商品保持全新未使用状态，包装完好</li>
          <li>配件、说明书、保修卡等齐全</li>
          <li>无划痕、无损坏、无污渍</li>
          <li>防伪标签未损坏、未撕毁</li>
          <li>保留购物凭证和发票</li>
        </ul>
      </section>

      <!-- 退款政策 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">二、退款政策</h2>
        
        <h3 class="font-medium text-lg mb-2">2.1 退款条件</h3>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>商品存在质量问题，经检测确认</li>
          <li>商品与描述不符，经核实确认</li>
          <li>7天无理由退换货，商品符合退换条件</li>
          <li>订单取消且未发货</li>
          <li>商品缺货无法发货</li>
          <li>配送超时且用户要求退款</li>
        </ul>
        
        <h3 class="font-medium text-lg mb-2">2.2 退款方式及时限</h3>
        <table class="w-full border-collapse mb-4">
          <thead>
            <tr class="bg-neutral-50">
              <th class="border border-neutral-200 p-2 text-left">支付方式</th>
              <th class="border border-neutral-200 p-2 text-left">退款方式</th>
              <th class="border border-neutral-200 p-2 text-left">退款时限</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-neutral-200 p-2">微信支付</td>
              <td class="border border-neutral-200 p-2">原路退回至微信账户</td>
              <td class="border border-neutral-200 p-2">1-3个工作日</td>
            </tr>
            <tr>
              <td class="border border-neutral-200 p-2">支付宝</td>
              <td class="border border-neutral-200 p-2">原路退回至支付宝账户</td>
              <td class="border border-neutral-200 p-2">1-3个工作日</td>
            </tr>
            <tr>
              <td class="border border-neutral-200 p-2">银行卡</td>
              <td class="border border-neutral-200 p-2">原路退回至银行卡</td>
              <td class="border border-neutral-200 p-2">3-7个工作日</td>
            </tr>
            <tr>
              <td class="border border-neutral-200 p-2">货到付款</td>
              <td class="border border-neutral-200 p-2">退回至用户指定银行卡/微信/支付宝</td>
              <td class="border border-neutral-200 p-2">3-5个工作日</td>
            </tr>
            <tr>
              <td class="border border-neutral-200 p-2">礼品卡/优惠券</td>
              <td class="border border-neutral-200 p-2">退回至用户账户，有效期延长</td>
              <td class="border border-neutral-200 p-2">1个工作日</td>
            </tr>
          </tbody>
        </table>
        
        <h3 class="font-medium text-lg mb-2">2.3 退款金额计算</h3>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc">
          <li>全额支付订单：退款金额 = 实付金额（含优惠券、礼品卡）</li>
          <li>部分退款订单：按商品金额比例退款</li>
          <li>使用优惠券的订单：优惠券在有效期内可退回，过期则不予补发</li>
          <li>包邮商品退货：我们承担发货运费，用户承担退回运费</li>
          <li>非包邮商品退货：用户承担双向运费</li>
        </ul>
      </section>

      <!-- 争议处理 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">三、争议处理</h2>
        
        <h3 class="font-medium text-lg mb-2">3.1 争议类型</h3>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>商品质量争议</li>
          <li>商品与描述不符争议</li>
          <li>配送服务争议</li>
          <li>售后服务争议</li>
          <li>价格争议</li>
          <li>发票争议</li>
        </ul>
        
        <h3 class="font-medium text-lg mb-2">3.2 争议处理流程</h3>
        <ol class="space-y-3 text-neutral-600 pl-5 list-decimal mb-4">
          <li>用户提交争议申请，提供相关证据（照片、视频、检测报告等）</li>
          <li>客服在24小时内受理，与用户沟通了解情况</li>
          <li>如需检测，用户将商品寄回指定检测中心</li>
          <li>检测/核实后，在3个工作日内给出处理方案</li>
          <li>双方达成一致，执行处理方案（退款、换货、补发等）</li>
          <li>如无法达成一致，可申请平台仲裁或向监管部门投诉</li>
        </ol>
        
        <h3 class="font-medium text-lg mb-2">3.3 举证责任</h3>
        <p class="text-neutral-600 mb-3">
          商品质量问题：由商家承担举证责任，证明商品无质量问题
        </p>
        <p class="text-neutral-600 mb-3">
          商品与描述不符：由用户举证，商家核实
        </p>
        <p class="text-neutral-600">
          配送问题：由物流公司提供证明，平台核实
        </p>
      </section>

      <!-- 特殊情况处理 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">四、特殊情况处理</h2>
        
        <h3 class="font-medium text-lg mb-2">4.1 商品损坏/丢失</h3>
        <p class="text-neutral-600 mb-3">
          配送过程中商品损坏/丢失：由物流公司和平台承担责任，为用户补发或退款
        </p>
        <p class="text-neutral-600 mb-3">
          用户签收后发现损坏：如能证明非用户原因，平台将协助处理
        </p>
        
        <h3 class="font-medium text-lg mb-2">4.2 假货处理</h3>
        <p class="text-neutral-600 mb-3">
          经权威机构检测确认是假货，平台将：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>全额退款</li>
          <li>按商品金额的3倍进行赔偿（最高不超过5000元）</li>
          <li>承担检测费用和运费</li>
          <li>对商家进行处罚，情节严重的移交司法机关</li>
        </ul>
        
        <h3 class="font-medium text-lg mb-2">4.3 价格保护</h3>
        <p class="text-neutral-600 mb-3">
          部分商品支持7天价格保护：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc">
          <li>用户购买商品后7天内，如商品降价，可申请价格补差</li>
          <li>需在"我的订单"中申请价格保护</li>
          <li>秒杀、团购、限时特惠等活动商品不支持价格保护</li>
        </ul>
      </section>

      <!-- 申诉渠道 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">五、申诉渠道</h2>
        <p class="text-neutral-600 mb-3">
          如果您对退款/争议处理结果不满意，可以通过以下渠道申诉：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>在线申诉："我的订单-售后-申诉"</li>
          <li>客服热线：400-123-4567（9:00-22:00）</li>
          <li>申诉邮箱：complaint@eliteshop.com</li>
          <li>平台仲裁：提交仲裁申请，3个工作日内给出仲裁结果</li>
        </ul>
        
        <p class="text-neutral-600">
          我们承诺在收到申诉后5个工作日内给出最终处理结果。
          如对平台处理结果仍不满意，您可以向消费者协会投诉或通过法律途径解决。
        </p>
      </section>

      <!-- 附则 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">六、附则</h2>
        <p class="text-neutral-600 mb-3">
          1. 本政策未尽事宜，按照国家相关法律法规执行。
        </p>
        <p class="text-neutral-600 mb-3">
          2. 我们有权根据法律法规和业务发展需要调整本政策，调整后将通过网站公告。
        </p>
        <p class="text-neutral-600">
          3. 本政策的解释权归EliteShop所有。
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RefundPolicy'
}
</script>